import ToggleButton from 'components/Buttons/ToggleButton';
import { Col, Row } from 'react-bootstrap';

const SettingButton = ({
  displayName,
  settingName,
  deviceSettings,
  device,
  setDeviceSettings,
  enabled = true,
}) => {
  const normalizeForCompare = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'boolean') return value ? 1 : 0;

    if (typeof value === 'string') {
      const lowered = value.toLowerCase();
      if (lowered === 'true' || lowered === 'false') return lowered === 'true' ? 1 : 0;

      const numeric = Number(value);
      if (!Number.isNaN(numeric)) return numeric;
    }

    const numeric = Number(value);
    if (!Number.isNaN(numeric)) return numeric;

    return value;
  };

  const getOriginalValue = () => {
    const original = device?.device_settings?.[settingName];

    const fallbackMap = {
      hResImgEnable: 2,
      ffiImgEnable: 0,
      imageRequest: 0,
      gpsSync: 0,
      imgHoldEnable: 0,
    };

    if (
      (original === null || original === undefined) &&
      Object.prototype.hasOwnProperty.call(fallbackMap, settingName)
    )
      return fallbackMap[settingName];

    return original;
  };

  return (
    <Row className="align-items-center g-2 mb-2">
      <Col lg={6} className="d-flex align-items-center gap-2">
        <label className="fw-semibold mb-0">{displayName}:</label>
      </Col>
      <Col lg={6} className="d-flex justify-content-lg-end justify-content-start">
        <ToggleButton
          isOff={
            settingName === 'hResImgEnable'
              ? deviceSettings[settingName] > 1
              : !deviceSettings[settingName]
          }
          onClick={
            enabled
              ? () => {
                  let newValue;

                  if (settingName === 'hResImgEnable')
                    newValue = deviceSettings[settingName] === 1 ? 2 : 1;
                  else newValue = deviceSettings[settingName] === 0 ? 1 : 0;

                  setDeviceSettings({
                    ...deviceSettings,
                    [settingName]: newValue,
                  });
                }
              : () => {}
          }
          enabled={enabled}
        />
      </Col>
    </Row>
  );
};

export default SettingButton;
